export const styles = {
    pageList: {padding:"15px", display:"flex", alignItems:"center", justifyContent:"space-between"},
    imageContainer:{border:"1px solid #dee2e0", width:"52px", height:"52px", background:"#dee2e0", borderRadius:"3px"},
    image:{borderRadius:"2px", maxWidth:"50px", maxHeight: "50px"},
    labelsContainer:{width:"auto", height:"45px", marginLeft:"15px"},
    buttonHolder:{display:"flex", justifyContent:"flex-end", marginTop:"20px"},
    checkboxHolder:{height:"50px"}
};